module.exports = __webpack_public_path__ + "static/onepager-mountains-00e30f1a29bde46b9379349adcc61df2.png";